import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { Button } from '@shared';

@Component({
  selector: 'lib-confirm-dialog',
  imports: [Button, MatDialogClose],
  templateUrl: './confirm-dialog.html',
  styleUrl: './confirm-dialog.css',
})
export class ConfirmDialog {
  data = inject<{
    title: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
  }>(MAT_DIALOG_DATA);
}
